import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["options", "onChange", "value", "iconComponent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as i, jsx as c } from "react/jsx-runtime";
import A, { useState as G, useEffect as T } from "react";
import { Select as N } from "../Select/Select.js";
import { c as I } from "../../../clsx-OuTLNxxd.js";
const E = "CountrySelect-module_wrapper__JNXAV",
  R = "CountrySelect-module_select__l6i2O",
  B = "CountrySelect-module_selected-country__qaLQZ",
  m = "CountrySelect-module_disabled__4bdRe",
  p = "CountrySelect-module_icon__lfnIp",
  y = "CountrySelect-module_state-invalid__RDpDJ",
  n = {
    wrapper: E,
    select: R,
    selectedCountry: B,
    disabled: m,
    icon: p,
    stateInvalid: y
  };
function L(e) {
  return S(e[0]) + S(e[1]);
}
function S(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
const P = ["AC", "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "EU", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "IC", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TA", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XK", "YE", "YT", "ZA", "ZM", "ZW"];
function K(e) {
  return P.indexOf(e) >= 0;
}
const _ = (e, M) => {
    const {
        options: l,
        onChange: C,
        value: t,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        iconComponent: F
      } = e,
      a = _objectWithoutProperties(e, _excluded),
      r = t && K(t) ? L(t) : void 0,
      [s, d] = G(void 0);
    return T(() => {
      (async () => {
        const {
          getCountryCallingCode: u
        } = await import("react-phone-number-input/min");
        try {
          d(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          t ? u(t) : void 0);
        } catch (_unused) {
          d(void 0);
        }
      })();
    }, [t]), /* @__PURE__ */i("div", {
      className: n.wrapper,
      children: [/* @__PURE__ */c(N, _objectSpread(_objectSpread({
        ref: M
      }, a), {}, {
        value: t,
        className: n.select,
        dataContentPiece: "select_phone_country",
        onChange: o => {
          C && C(o.target.value);
        },
        children: l == null ? void 0 : l.map(o => /* @__PURE__ */c("option", {
          value: o.value,
          children: o.label
        }, o.label))
      })), /* @__PURE__ */i("div", {
        className: I(n.selectedCountry, {
          [n.disabled]: a.disabled,
          [n.stateInvalid]: a.validationState == "error"
        }),
        children: [r && /* @__PURE__ */c("span", {
          className: n.icon,
          children: r
        }), " ", s && "+".concat(s)]
      })]
    });
  },
  v = /* @__PURE__ */A.forwardRef(_);
export { v as default };